import {
  GraphFilterTimeRangeOption,
  GraphFilterViewTypeOption,
} from './graph-filter.interface';

export const GraphFilterViewTypeOptions: GraphFilterViewTypeOption[] = [
  { label: 'Day', value: 1, isEnabled: false },
  { label: 'Week', value: 2, isEnabled: false },
  { label: 'Month', value: 3, isEnabled: false },
  { label: 'Quarter', value: 4, isEnabled: false },
  { label: 'Year', value: 5, isEnabled: false },
];

export const GraphFilterTimeRangeOptions: GraphFilterTimeRangeOption[] = [
  { label: 'Day', value: 0, type: 'day' },
  { label: 'Week', value: 1, type: 'week' },
  { label: 'Month', value: 2, type: 'month' },
  { label: 'Quarter', value: 3, type: 'quarter' },
  { label: 'Year', value: 4, type: 'year' },
  { label: 'Range', value: 5, type: 'range' },
];
